const moduloConciliacionBan = {
  agGrid: {
    paginacion: 15,
    id: 'myGrid',
    // class: 'ag-theme-material mt-3',
    class: 'ag-theme-alpine mt-3',
    style: {
      width: '100%',
      height: '700px'
    }
  },
  url: {
    conciliacionBancaria: {
      // conciBanc:'conci-banc/',
      // ConciBanca: 'param-conci-banca',

      banco: 'banco/findParam/',
      empresa: 'empresa',
      obtenerConci: '/paramAutoServiciosPK',
      bancoCuenta: 'bancoCuenta/findParam/',

      //extractoBancario: 'conci-banc-cobros/uploadFileForCuerpo',
      extractoBancario: '/cobros/uploadFileForCuerpo',
      getAllextractoBancario: 'conci-banc-cobros',
      autorizarCobros: {
        getCobrosPendientes: 'cobros/pending',
        rechazarCobro: '/cobros/rechazar/',
        procesarCobro: '/cobros/desbloquear-pago',
        procesarCobroMasive: '/cobros/desbloquear-pago-masive'
      },

      conciBancParam: 'conci-banc/param',
      conciBancparametro: 'conci-banc/parametro',
      findFormato: 'conci-banc/param/findFormato',
      findFormatoplus: 'conci-banc/parametro/findFormato',
      uploadDocSAP: 'conci-banc/uploadFileForSAP',
      uploadDocSAPplus: 'conci-banc/custom/uploadFileForSAP',
      uploadDoc: 'conci-banc/uploadFileForCuerpo',
      uploadDocplus: 'conci-banc/custom/uploadFileForCuerpo',
      reglasBanca: 'conci-banc/reglas-banca',

      DataBancaServ: 'conci-banca-servicios',
      clienteFind: 'cliente/findParam?cliDesde=',
      //parametros
      // idempresa: '?idEmpresa=',
      // idBanco: '&idBanco=',
    },
    parametros: {
      idempresa: '?idEmpresa=',
      idBanco: '&idBanco=',
    },
    configuracionFeriados: {
      crud:'param-extractos-feriados',
    }

  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',
      primaryOutline: 'btn btn-outline-primary',
      secondaryOutline: 'btn btn-outline-secondary',
      successOutline: 'btn btn-outline-success',
      dangerOutline: 'btn btn-outline-danger',
      warningOutline: 'btn btn-outline-warning',
      infoOutline: 'btn btn-outline-info',
      lightOutline: 'btn btn-outline-light',
      darkOutline: 'btn btn-outline-dark',
      primarylg: 'btn btn-primary btn-lg btn-block',
    },
    buttonsNombre: {
      editar: 'Editar',
      ver: 'Ver',
      eliminar: 'Eliminar',
      agregar: 'Agregar ',
      guardar: 'Guardar',
      actualizar: 'Actualizar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      seleccionar: 'Seleccionar',
      procesar: 'Procesar',
      sustento: 'Sustento',
      validar: 'Validar',
      descargar: 'Descargar',
      descargarRecibo: 'Descargar Recibo Cobros',
      descargarEstado: 'Descargar Estados Docs',
      catalogo: 'Añadir Catalogo',
      buscar: 'Buscar',
      verPedidos: 'Ver Pedidos',
      rechazar: 'Rechazar'
    }
  },
  mensajes: {
    errorServicio: 'error..!!',
    desabilitada: 'Opción desabilitada',
    eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
    guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
    datoGuardado: 'Se guardo corectamente..!!',
    guardarParada: 'Esta seguro que desea registrar este evento..??',
    procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
    validar: '¿Esta seguro que desea validar el siguiente elemento?',
    anticipo: 'Se tomara este valor como anticipo.',
    rechazar: '¿Esta seguro que desea rechazar el siguiente elemento?'
  },
  titulos: {
    autorizacionCobros: {
      titulo: 'Autorizador de Cobros',
      modulo: 'Financiero',
      tituloCardListar: 'Listar Cobros',
      tituloCardGuardar: 'Guardar Cobros',
      tituloCardEditar: 'Editar Cobros',
      tituloCardPedidos: 'Pedidos',
      tituloCardProcesarExtractos: 'Procesar Cobros',
    },
    global: {
      tituloAgregar   : 'Agregar Nuevo Registro',
      tituloActualizar: 'Actualizar Registro',
      tituloEliminar  : 'Eliminar Registro',
    },
    Feriados: {
      titulo: 'Fechas Feriados',
      modulo: 'Financiero',
      tituloCardListar: 'Listar Fechas',
      tituloCardGuardar: 'Guardar Fecha',
      tituloCardEditar: 'Editar Fechas',
      tituloCardPedidos: 'FEchas Feriados'
    },
  }

}


export {moduloConciliacionBan}
